import { defineStore } from 'pinia';
import { getToken, setToken, removeToken } from '@/utils/auth';
import { type userType } from './types';

export const useUserStore = defineStore('user', {
  state: (): userType => ({
    token: getToken() || '',
    userInfo: {},
    position: {lon: 116.404, lat: 39.915},
  }),
  actions: {
    setToken(token: string) {
      this.token = token;
      setToken(token);
    },
    removeToken() {
      this.token = '';
      removeToken();
    },
    setUserInfo(userInfo: object) {
      this.userInfo = userInfo;
    },
    setPosition(position: object) {
      this.position = position;
    },
  },
});
